import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {ErrorMessage} from '../../../../shared/models/error-message';
import {
  StatusService,
  StatusSuccessMessageEnum,
} from '../../../../shared/services/authentication/status.service';

import {validatorCNPJ, validatorCPF} from '../../../../utils/validators';
import CpfHelper from '../../../../helpers/cpf.helper';
import {SellerPJDataPayload} from "../../../../shared/models/sellerPj.model";
import { addCorporateNameSanitizer, addNameSanitizers, corporateNameValidator, emailValidator, textMinCharsValidator, textNoSpecialCharsValidator } from '../../../../helpers/validate-form.helper';
import { phoneMask } from '../../../../utils/masks.utils';

@Component({
  selector: 'app-seller-procurator-pj',
  templateUrl: './seller-procurator-pj.component.html',
  styleUrls: ['./seller-procurator-pj.component.scss'],
})
export class SellerProcuratorPjComponent implements OnInit {
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private statusService: StatusService,
  ) {
  }

  @Input() dataCompany = new SellerPJDataPayload();

  @Input() formStepProcurator: FormGroup;

  @Input() formControls: FormControl[];

  @ViewChild('originModalRemoveProcurator') originModalRemoveProcurator: any;
  @Output() currentProcurators = new EventEmitter();

  count: number[] = []; //refatoracao pendente, verificar se existe a dependencia do count nesse componente

  initialCount = 0;

  phoneMask = phoneMask;

  maskCpfCnpj = CpfHelper.maskCpfCnpj;

  procuratorForm: any;
  currentItemSelected: any;
  currentIndexSelected: any;
  isOpenModalRemoveProcurator = false;
  procuratorRepresentationForm: any;

  ngOnInit(): void {
    this.createProcuratorRepresentationForm();
    this.createProcuratorForm();
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  createProcuratorRepresentationForm() {
    this.procuratorRepresentationForm = new FormGroup({
      useAttorneys: new FormControl('', Validators.required),
    });
  }

  createProcuratorForm() {

    this.procuratorForm = new FormGroup({
      procurators: new FormArray([]),
    });
    this.isFormComplete();
    this.setProcuratorsFromData();
  }

  get procuratorArray() {
    return this.procuratorForm.get('procurators') as FormArray;
  }

private buildProcuratorGroup(data: any = {}, index: number = 0): FormGroup {
  const group = new FormGroup({
    id: new FormControl(index + 1),
    name: new FormControl(data.name || '', [
      Validators.required,
      // pode deixar só o mínimo aqui; os validators específicos você já troca em setPessoaCPFValidator / setCNPJValidator
    ]),
    documentNumber: new FormControl(data.documentNumber || '', [Validators.required]),
    [`type${index}`]: new FormControl(data.type || '', Validators.required),
    email: new FormControl(data.email || '', [
      Validators.required,
      emailValidator
    ]),
    phone: new FormControl(data.phone || '', [
      Validators.required,
      Validators.minLength(10)
    ]),
  });


  return group;
}

getTextFieldError(index: number, controlName: string, label: string): string {
  const control = this.procuratorForm.get(['procurators', index, controlName]);
  return ErrorMessage.getTextFieldError(control, label);
}

getEmailFieldError(index: number, controlName: string, label: string): string {
  const control = this.procuratorForm.get(['procurators', index, controlName]) as AbstractControl | null;
  return ErrorMessage.getEmailFieldError(control, label);
}

normalizeEmail(index: number, controlName: string): void {
  const control = this.procuratorForm.get(['procurators', index, controlName]) as AbstractControl | null;
  if (!control) return;

  const value = (control.value || '').toString().trim().toLowerCase();

  if (value !== control.value) {
    control.setValue(value);
  }
}
  setProcuratorsFromData(): void {
    this.procuratorArray.clear();
    this.count = [];
    this.initialCount = 0;

    if (this.dataCompany?.attorneys?.length) {
      this.procuratorRepresentationForm.get('useAttorneys').setValue(true);
      this.dataCompany.attorneys?.forEach((attorney: any, idx: number) => {
        const group = this.buildProcuratorGroup(attorney, idx);
        this.procuratorArray.push(group);
        this.count.push(idx + 1);
        this.initialCount++;
      });
    } else {

      this.addProcurator();
    }
  }

  addProcurator() {
    const idx = this.procuratorArray.length;
    const group = this.buildProcuratorGroup({}, idx);
    this.procuratorArray.push(group);
    this.initialCount++;
    this.count.push(this.initialCount);
  }

  getProcuratorData(index: number) {
    const procurators = this.procuratorForm.get('procurators') as any;
    const selectedProcurator = procurators.at(index).value;
    this.currentItemSelected = selectedProcurator;
    this.currentIndexSelected = index;
  }

  removeProcurator(index: number) {
    // Obtenha os dados da procuradore no índice especificado
    this.getProcuratorData(index);

    // Obtenha a lista de procuradores
    const procurators = this.procuratorForm.get('procurators') as any;

    // Remova a procuradore no índice especificado da lista de procuradores
    procurators.removeAt(index);

    // Atualize o ID de todas as procuradores após o índice removido
    for (let i = index; i < procurators.length; i++) {
      // Obtenha a procuradore no índice i
      const procurator = procurators.at(i);

      // Obtenha o campo 'id' da procuradore
      const idField = procurator.get('id');

      // Atualize o valor do campo 'id'
      idField.setValue(i + 1);
    }

    //refatoracao pendente, verificar se existe a dependencia do count nesse componente
    this.count.splice(index, 1);
  }


  setIsOpenModalRemoveProcurator(index: number) {
    this.getProcuratorData(index);
    this.isOpenModalRemoveProcurator = true;
  }

  modalConfirmRemove() {
    this.removeProcurator(this.currentIndexSelected);
    this.statusService.showToast('success', StatusSuccessMessageEnum.EXCLUSION_PARTICIPANT);
    this.isOpenModalRemoveProcurator = false;
  }

  closeModal() {
    this.isOpenModalRemoveProcurator = false;
  }

  procuratorRadioChange(procurator: boolean) {
    if (procurator) {
      this.emitFormValues();
    } else {
      const procurators = this.procuratorForm.get('procurators') as FormArray;
      procurators.clear();
      this.addProcurator();
      this.procuratorForm.clearValidators();
      this.procuratorForm.markAsUntouched();
    }
  }
setPessoaCPFValidator(index: number) {
  const procurators = this.procuratorForm.get('procurators') as FormArray;
  const procurator = procurators.at(index) as FormGroup;

  // Limpa os valores dos campos
  procurator.controls['name'].setValue('');
  procurator.controls['email'].setValue('');
  procurator.controls['phone'].setValue('');


  const nameControl = procurator.get('name');
    if (!nameControl) {

    console.warn('name control não encontrado para procurator index', index);
    return;
  }
  nameControl.clearValidators();
  nameControl.updateValueAndValidity();
  nameControl.setValidators([
    Validators.required,
    textMinCharsValidator(),
    textNoSpecialCharsValidator(),
  ]);

  nameControl.updateValueAndValidity();

  addNameSanitizers(procurator, { controlNames: ['name'] }, true, index);

  this.resetCpfCnpj(index, false);
}

setCNPJValidator(index: number) {
  const procurators = this.procuratorForm.get('procurators') as FormArray;
  const procurator = procurators.at(index) as FormGroup;

  // Limpa os valores dos campos
  procurator.controls['name'].setValue('');
  procurator.controls['email'].setValue('');
  procurator.controls['phone'].setValue('');


  const nameControl = procurator.get('name');
    if (!nameControl) {

    console.warn('name control não encontrado para procurator index', index);
    return;
  }
  nameControl.clearValidators();
  nameControl.updateValueAndValidity();
  nameControl.setValidators([
    Validators.required,
    corporateNameValidator()
  ]);

 nameControl.updateValueAndValidity();
  // liga sanitizer de razão social
  addCorporateNameSanitizer(procurator, { controlNames: ['name'] }, true, index);

  this.resetCpfCnpj(index);
}

  resetCpfCnpj(index: number, cnpj = true) {
    const procurators = this.procuratorForm.get('procurators') as any;
    const procurator = procurators.at(index);
    const fieldCpfCnpj = procurator.get('documentNumber');

    fieldCpfCnpj.reset();
    fieldCpfCnpj.setValidators([Validators.required, cnpj ? validatorCNPJ : validatorCPF]);
    fieldCpfCnpj.updateValueAndValidity();
  }

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

  isFormComplete(): void {
    this.procuratorForm.statusChanges.subscribe(() => {
      this.emitFormValues();
    });
  }

  emitFormValues(): void {
    const formValues = this.procuratorRepresentationForm.getRawValue();
    if (formValues?.useAttorneys) {
      this.currentProcurators.emit({
        value: this.procuratorForm.value,
        formStatus: this.procuratorForm.status,
      });
    } else {
      this.currentProcurators.emit({
        value: [],
        formStatus: 'VALID',
      });
    }
  }
}
